import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import VisitaFiliadoTable from './components/VisitaFiliadoTable';
import VisitaFiliadoToolbar from './components/VisitaFiliadoToolbar/VisitaFiliadoToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { isAuthenticated } from '../../helpers/authenticate';
import Alert from '@material-ui/lab/Alert/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import moment from 'moment';
import InputAdornment from '@material-ui/core/InputAdornment';
import { IconButton, TextField } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { TextValidator } from 'react-material-ui-form-validator';
import { Values } from '../../values/Values';
import {
  deleteVisitaFiliado,
  getAllVisitaFiliado
} from '../../services/VisitaFiliadoService';
import BottomScrollListener from 'react-bottom-scroll-listener';
import DialogImpressaoVisitasGeral from './components/DialogImpressao';
import DialogRelatorioFiliados from '../../components/DialogRelatorioFiliados/DialogRelatorioFiliados';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab: {
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  }
}));

function VisitaFiliadoList({ history }) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  let [visitaFiliados, setVisitaFiliados] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [
    showDialogConfirmacaoDeleteVisitaFiliado,
    setShowDialogConfirmacaoDeleteVisitaFiliado
  ] = useState(false);
  const [selectedIndexVisitaFiliado, setSelectedIndexVisitaFiliado] = useState(
    -1
  );
  const [sucess, setSucess] = useState(true);
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  let [page, setPage] = useState(1);
  const [fimLista, setFimLista] = useState(false);
  const [refreshState, setRefreshState] = useState(new Date());
  const [paramsFiltroAtivo, setParamsFiltroAtivo] = useState();
  const [filtroAtivo, setFiltroAtivo] = useState();
  const [openDialogImpressao, setOpenDialogImpressao] = useState(false);
  const [openDialogRelatorioFiliados, setOpenDialogRelatorioFiliados] = useState(false);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    carregarVisitaFiliados();
  }, []);

  async function carregarVisitaFiliados() {
    try {
      setLoading(true);
      const params = {
        limit: Values.limiteRegistroLista,
        page: page
      };
      let dados;
      if (!filtroAtivo) {
        dados = await api.get('visita-filiados/', { params: params });
      } else {
        paramsFiltroAtivo.page = page;
        setParamsFiltroAtivo(paramsFiltroAtivo);
        dados = await api.get('visita-filiados/filter', {
          params: paramsFiltroAtivo
        });
      }

      setLoading(false);
      if (dados.data.isSuccess) {
        setPage(page + 1);
        let result = visitaFiliados.result;
        if (dados.data.result.length !== 0) {
          for (let i = 0, size = dados.data.result.length; i < size; i++) {
            dados.data.result[i].on_mouse_over = false;
            result.push(dados.data.result[i]);
          }
          setVisitaFiliados({
            isSuccess: dados.data.isSuccess,
            result: result,
            message: dados.data.message
          });
        } else {
          if (page === 1) {
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há visitas registradas');
            setShowMessageSnack(true);
          } else {
            setFimLista(true);
          }
        }
      } else {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.data.message);
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  function showConfirmationDeleteVisitaFiliado(index) {
    if (
      selectedIndexVisitaFiliado < 0 &&
      selectedIndexVisitaFiliado >= visitaFiliados.result.length
    ) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o visita');
      setShowMessageSnack(true);
    } else {
      setSelectedIndexVisitaFiliado(index);
      setShowDialogConfirmacaoDeleteVisitaFiliado(true);
    }
  }

  async function deleteVisita(event) {
    if (
      selectedIndexVisitaFiliado < 0 ||
      selectedIndexVisitaFiliado >= visitaFiliados.result.length
    ) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o visita');
      setShowMessageSnack(true);
    } else {
      try {
        setShowDialogConfirmacaoDeleteVisitaFiliado(false);
        setLoading(true);
        const visitaFiliadoDelete =
          visitaFiliados.result[selectedIndexVisitaFiliado];
        const auth = JSON.parse(localStorage.getItem('auth'));
        const deleteVisita = await deleteVisitaFiliado(
          visitaFiliadoDelete,
          senha,
          auth.result.idUsuario
        );
        setSenha('');
        setLoading(false);
        if (deleteVisita.isSuccess) {
          setTypeSnack('success');
          setMessageSnack(deleteVisita.message);
          setShowMessageSnack(true);
          page = 1;
          setPage(1);
          setFimLista(false);
          let visitas = await getAllVisitaFiliado(1, 100);
          setVisitaFiliados(visitas);
          setRefreshState(new Date());
        } else {
          setTypeSnack('error');
          setMessageSnack(deleteVisita.message);
          setShowMessageSnack(true);
        }
      } catch (e) {
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    }
  }

  function onCancelDeleteVisitaFiliado() {
    setSelectedIndexVisitaFiliado(-1);
    setShowDialogConfirmacaoDeleteVisitaFiliado(false);
  }

  async function filterVisitaFiliados(
    descricaoFiliado,
    dataEntradaInicial,
    dataEntradaFinal,
    dataSaidaInicial,
    dataSaidaFinal,
    visitaEncerrada
  ) {
    try {
      setLoading(true);
      page = 1;
      const params = {
        limit: Values.limiteRegistroLista,
        page: page,
        descricaoFiliado: descricaoFiliado,
        dataEntradaInicial: dataEntradaInicial,
        dataEntradaFinal: dataEntradaFinal,
        dataSaidaInicial: dataSaidaInicial,
        dataSaidaFinal: dataSaidaFinal,
        visitaEncerrada: visitaEncerrada
      };
      setParamsFiltroAtivo(params);
      setFiltroAtivo(true);
      setPage(2);
      setFimLista(false);
      const dados = await api.get('visita-filiados/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setVisitaFiliados(dados.data);
      } else {
      }
    } catch (e) {
      console.log(e.toString());
    }
  }

  function openVisitaFiliadoRegisterDetalhado() {
    const visitaFiliado = {
      idVisitaFiliado: undefined,
      idFiliado: '',
      filiado: undefined,
      dataEntrada: new Date(),
      dataSaida: undefined,
      visitaEncerrada: false,
      valorTotal: 0,
      descontoTotal: 0,
      valorHoraClube: 0,
      insumosAdicionais: []
    };
    history.push('/visita-filiado-register-detalhado/', {
      visitaFiliado: visitaFiliado,
      edicao: false
    });
  }

  async function openVisitaFiliadoEditDetalhado(index) {
    try {
      if (index < 0 && index >= visitaFiliados.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar o visita');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(
          `visita-filiados/${visitaFiliados.result[index].idVisitaFiliado}`
        );
        setLoading(false);
        if (dados.data.isSuccess) {
          if (dados.data.result.length > 0) {
            history.push('/visita-filiado-edit-detalhado/', {
              visitaFiliado: dados.data.result[0],
              edicao: true
            });
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados da visita.');
            setShowMessageSnack(true);
          }
        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados do visita.');
          setShowMessageSnack(true);
        }
      }
    } catch (e) {
      setSucess(false);
    }
  }

  async function openVisitaFiliadoEditPreview(index) {
    try {
      if (index < 0 && index >= visitaFiliados.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar o visita');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(
          `visita-filiados/${visitaFiliados.result[index].idVisitaFiliado}`
        );
        setLoading(false);
        if (dados.data.isSuccess) {
          if (dados.data.result.length > 0) {
            history.push('/visita-filiado-preview/', {
              visitaFiliado: dados.data.result[0],
              edicao: true
            });
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados da visita.');
            setShowMessageSnack(true);
          }
        } else {
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados do visita.');
          setShowMessageSnack(true);
        }
      }
    } catch (e) {
      setSucess(false);
    }
  }

  async function carregarMais() {
    if (!fimLista) {
      await carregarVisitaFiliados();
    }
  }

  return sucess ? (
    <BottomScrollListener
      onBottom={e => carregarMais()}
      offset={50}
      debounce={100}>
      <div className={classes.root}>
        <DialogImpressaoVisitasGeral
          open={openDialogImpressao}
          setOpen={setOpenDialogImpressao}
        />
        <DialogRelatorioFiliados
          open={openDialogRelatorioFiliados}
          setOpen={setOpenDialogRelatorioFiliados}
        />
        <VisitaFiliadoToolbar
          filterVisitaFiliados={filterVisitaFiliados}
          setOpenImpressao={setOpenDialogImpressao}
          setOpenRelatorioFiliados={setOpenDialogRelatorioFiliados}
        />
        <SnackbarCustom
          verticalOrientation="bottom"
          horizontalOrientation="center"
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <Dialog
          open={showDialogConfirmacaoDeleteVisitaFiliado}
          aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">
            Tem certeza que deseja remover essa visita?
          </DialogTitle>
          <DialogContent>
            <Alert severity="warning" variant="outlined">
              <AlertTitle>Atenção</AlertTitle>A remoção de uma visita implica em
              uma série de responsabilidades para o usuário e para o filiado.
              Para garantir a integridade do sistema e do usuário, por favor
              digite sua senha de acesso ao sistema para confirmar essa ação
            </Alert>
            <Typography gutterBottom style={{ marginTop: '30px' }}>
              {selectedIndexVisitaFiliado >= 0 &&
                selectedIndexVisitaFiliado < visitaFiliados.result.length &&
                'Nome do visitante: ' +
                  visitaFiliados.result[selectedIndexVisitaFiliado].filiado
                    .nome}
            </Typography>
            <Typography gutterBottom>
              {selectedIndexVisitaFiliado >= 0 &&
                selectedIndexVisitaFiliado < visitaFiliados.result.length &&
                'CPF: ' +
                  visitaFiliados.result[selectedIndexVisitaFiliado].filiado.cpf}
            </Typography>
            <Typography gutterBottom>
              {selectedIndexVisitaFiliado >= 0 &&
                selectedIndexVisitaFiliado < visitaFiliados.result.length &&
                'Data entrada: ' +
                  moment(
                    visitaFiliados.result[selectedIndexVisitaFiliado]
                      .dataEntrada
                  ).format('DD/MM/YYYY HH:mm')}
            </Typography>
            <Typography gutterBottom style={{ marginBottom: '30px' }}>
              {selectedIndexVisitaFiliado >= 0 &&
                selectedIndexVisitaFiliado < visitaFiliados.result.length &&
                ((visitaFiliados.result[selectedIndexVisitaFiliado].dataSaida &&
                  'Data saída: ' +
                    moment(
                      visitaFiliados.result[selectedIndexVisitaFiliado]
                        .dataSaida
                    ).format('DD/MM/YYYY HH:mm')) ||
                  'Data saída: Não informado')}
            </Typography>
            <TextField
              id="outlined-adornment-password"
              variant="outlined"
              margin="dense"
              fullWidth
              value={senha}
              type={mostrarSenha ? 'text' : 'password'}
              label="Informe a senha"
              onChange={e => setSenha(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      aria-label="toggle password visibility"
                      onClick={e => setMostrarSenha(!mostrarSenha)}>
                      {mostrarSenha ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              helperText="Insira sua senha para confirmação de exclusão dessa visita."
              validators={['required']}
              errorMessages={['Senha']}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={e => onCancelDeleteVisitaFiliado()}
              color="primary">
              Cancel
            </Button>
            <Button onClick={e => deleteVisita(e)} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.content}>
          <ProgressFullScreen open={loading} setOpen={setLoading} />

          <VisitaFiliadoTable
            visitaFiliados={visitaFiliados}
            setVisitaFiliados={setVisitaFiliados}
            deleteVisitaFiliado={showConfirmationDeleteVisitaFiliado}
            editVisitaFiliado={openVisitaFiliadoEditDetalhado}
            previewVisitaFiliado={openVisitaFiliadoEditPreview}
            showMessageSnack={showMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            messageSnack={messageSnack}
            setMessageSnack={setMessageSnack}
            typeSnack={typeSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
        <div className={classes.divFab}>
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant={'round'}
            onClick={openVisitaFiliadoRegisterDetalhado}>
            <AddIcon />
          </Fab>
        </div>
      </div>
    </BottomScrollListener>
  ) : (
    <NotFoundView />
  );
}

export default VisitaFiliadoList;
